export default __webpack_public_path__ + "static/media/methodologist-1.d85ba4c8.png";